export class GeneralInfo
{
    vin:string;
    year:string;
    make:string;
    model:string;
    color:string;
    plate:string;
    towedDate:Date;
    isSearched:boolean;
    isSelected:boolean;


/**
 *
 */
constructor() {    
this.isSearched=false;
 this.vin="";
 this.year="";
 this.make="";
 this.model="";
 this.plate="";
 this.towedDate=null;
 this.isSelected=false;
}
}



// WEBPACK FOOTER //
// ./src/app/ViewModels/TowLocateViewModels/GeneralInfo.ts